import { useMemo } from 'react';
import { useGetScheduleRequestAndAlertsCount } from '../../../../hooks/use-get-schedule-request-and-alerts-count';
import { ScheduleActionsContextType, ScheduleActionsContext } from './ScheduleActionsContext';

export const ScheduleActionsProvider = ({
  children,
  closeModal,
}: React.PropsWithChildren<{ closeModal?: () => void }>) => {
  const {
    isAppointmentRequestCountLoading,
    isScheduleAlertsLoading,
    refetchAlertCount,
    scheduleAlertsCount,
    scheduleRequestCount,
    refetchAppointmentRequestCount,
  } = useGetScheduleRequestAndAlertsCount();

  const providerValue = useMemo<ScheduleActionsContextType>(
    () => ({
      isAppointmentRequestCountLoading,
      isScheduleAlertsLoading,
      closeModal: closeModal ? closeModal : () => {},
      refetchAlertCount: () => refetchAlertCount(),
      scheduleAlertsTotalCount: scheduleAlertsCount ?? 0,
      scheduleRequestsTotalCount: scheduleRequestCount?.total ?? 0,
      refetchAppointmentRequestCount: () => refetchAppointmentRequestCount(),
      scheduleRequestsCountByLocation: scheduleRequestCount?.locationScheduleRequestCounts ?? [],
      closeScheduleActionsModal: closeModal ? closeModal : () => {},
    }),
    [scheduleAlertsCount, scheduleRequestCount, isScheduleAlertsLoading, isAppointmentRequestCountLoading, closeModal]
  );

  return <ScheduleActionsContext.Provider value={providerValue}>{children}</ScheduleActionsContext.Provider>;
};
